import { InstructorAfter, InstructorBefore } from '@berlitz/icons'
import * as React from 'react'
import { InjectedIntlProps, injectIntl } from 'react-intl'

import Tooltip from '../../../components/Tooltip'
import { GroupClassListItem } from '../../../interfaces/MySchedule'
import { GroupName } from './style'

interface Prop {
  sched: GroupClassListItem
}

const LessonGroupName: React.FC<InjectedIntlProps & Prop> = ({ intl, sched }) => (
  <GroupName>
    {sched.GroupName}
    <div>
      {(sched.PrevInstructors || []).map(({ Name }) => (
        <Tooltip
          key={`prev-instructor-${Name}`}
          message={
            <div className="text-center">
              {intl.formatMessage({
                id: 'Previous instructor',
              })}
              :
              <br />
              {Name}
            </div>
          }
        >
          <InstructorBefore size="sm" />
        </Tooltip>
      ))}
      {(sched.NextInstructors || []).map(({ Name }) => (
        <Tooltip
          key={`next-instructor-${Name}`}
          message={
            <div className="text-center">
              {intl.formatMessage({
                id: 'Next instructor',
              })}
              :
              <br />
              {Name}
            </div>
          }
        >
          <InstructorAfter size="sm" />
        </Tooltip>
      ))}
    </div>
  </GroupName>
)

export default injectIntl(LessonGroupName)
